<template>
  <div class="content">
    <!-- 预览模态 -->
    <div class="single-wrap" @click="cutEdit" >
      <div class="single-box">
        <div class="box-f">
          <span v-if="!isTestEdit && !istestPreview && !isBankViewTest">{{ question.quesIndex + 1 }}</span>
          <div style="padding: 0px 10px;box-sizing: border-box;width: 80%;" @click="setActiveInput(question.qid)">
            <span v-if="(isBankViewTest || istestPreview) && question.questionsName">{{question.questionsName}}</span>
            <TitleEditor 
              v-if="!isBankViewTest && !istestPreview" 
              class="outline-none" 
              :qid="question.qid" 
              :class="question.qid"  
              :value="question.questionsName" 
              :actionTitleEditorShow="activeInputId === question.qid"
              @childValueChange="val=>{ question.questionsName = val }" 
            ></TitleEditor>
          </div>
          <span class="title-score">（最高分值：{{question.score}}分）</span>
        </div>
        <OperateaWrap 
          v-if="!isTestEdit && !istestPreview && !istestPreview" 
          :isBank="isBank"
          :isBankViewTest="isBankViewTest"
          :question="question"
          :bankList="bankList"
          @getBankList="$emit('getBankList')"
          @addToBank="(question, id) => $emit('addToBank', question, id)"
          @addBank="(bankForm, qid) => $emit('addBank', bankForm, qid)"
          @copyQuestion="copyQuestion"
          @delQuestion="delQuestion"
          @delFormBank="(question) => $emit('delFormBank', question)"
        />
      </div>
      <div v-if="associatedList.length > 0" class="option associated">
        <div class="option-item" v-for="el in associatedList" :key="el.id">
          <div class="el-icon-d-arrow-right"></div>
          关联自Q{{el.quesIndex + 1}}的{{el.optionList.length}}个选项
          <span v-for="(optionItem, opIndex) in el.optionList" :key="optionItem.oid">{{opIndex == 0 ? '' : '、'}}{{$functions.htmlFormat(optionItem.labelName)}}</span>
        </div>
      </div>
      <ul class="option">
        
        <draggable
          style="width: 100%;"
          v-bind="draggableOptions"
          v-model="question.optionList"
        >
          <transition-group
            style="width: 100%;"
            tag="div"
            type="transition"
            :name="'flip-list'"
          >
            <li
              class="option-li"
              :label="it.labelName"
              @mouseenter="editOptionIndex = indexoption"
              @mouseleave="editOptionIndex = -1"
              v-for="(it, indexoption) in question.optionList"
              :key="indexoption"
              :style="{width: question.showcolnum == 1?'100%':(question.showcolnum == 2?'50%':(question.showcolnum == 3?'30.3%':'25%'))}"
            >
            <div class="option-li-div">
              <i v-if="question.questionsTypeId == 101" class="circle-checkbox"></i>
              <i v-else class="circle-radio"></i>
              <div class="div-input" @click="setActiveInput(it.oid)">
                <TitleEditor 
                  v-if="!isBankViewTest && !istestPreview" 
                  class="outline-none" 
                  :qid="it.oid" 
                  :class="it.oid"  
                  :value="it.labelName" 
                  :actionTitleEditorShow="activeInputId === it.oid"
                  @childValueChange="val=>{ it.labelName = val }" 
                ></TitleEditor>
                <span v-if="isBankViewTest || istestPreview">{{it.labelName}}</span>
              </div>
            </div>
            <template v-if="!istestPreview">
              <div
                class="control"
                v-if="editOptionIndex == indexoption"
              >
                <el-tooltip placement="top" effect="light">
                  <div slot="content">长按拖动</div>
                  <i class="option-handle el-icon-rank el-icon-common-option" ></i>
                </el-tooltip>
                
                <el-tooltip placement="top" effect="light">
                  <div slot="content">设置</div>
                  <i class="el-icon-s-tools el-icon-common-option" @click.stop="setQuestionOption(it)"></i>
                </el-tooltip>
                
                <el-tooltip placement="top" effect="light">
                  <div slot="content">删除</div>
                  <i
                    v-if="question.optionList.length != 1 || question.relation.length > 0"
                    class="el-icon-remove el-icon-common-option"
                    @click="delOptionOne(it.oid, indexoption)"
                  ></i>
                </el-tooltip>
              </div>
              <div 
                v-if="it.haveInput && editOptionIndex != indexoption"
                class="other-input">
                <el-input
                  disabled
                  size="mini"
                  v-model="value"
                  >
                </el-input>
              </div>
              <span v-if="question.questionsTypeId == 101">
                <span v-show="question.answer.indexOf(it.oid) != -1 && question.scoringType != 3 && editOptionIndex != indexoption" class="option-true">(正确答案)</span>
              </span>
              <span v-else>
                <span v-show="question.answer == it.oid && question.scoringType == 1 && editOptionIndex != indexoption" class="option-true">(正确答案)</span>
              </span>
            </template>
            <template v-else>
              <span v-if="question.questionsTypeId == 101">
                <span v-show="question.answer.indexOf(it.oid) != -1 && question.scoringType != 3 " class="option-true">(正确答案)</span>
              </span>
              <span v-else>
                <span v-show="question.answer == it.oid && question.scoringType == 1" class="option-true">(正确答案)</span>
              </span>
            </template>
              
            </li>
          </transition-group>
        </draggable>
      </ul>
    </div>

    <!-- 编辑模态 -->
    <div v-if="question.isedit && !istestPreview && !isBankViewTest && question.questionsTypeId != 102 " class="option-bottom">
      <el-button type="text" @click="addOption"
        >添加选项</el-button
      >
      <el-button type="text" @click="isdialogshow = true">批量添加</el-button>
      
      <el-button type="text" @click="addOther">添加其他</el-button>
      <el-button type="text" @click="setAnswer">设置答案解析</el-button>
      <!-- 选项关联 -->
      <OptionAssociation ref="OptionAssociation" v-if="!$route.query.bankId" :paper="paper" ></OptionAssociation>
    </div>
    <!-- 最外层的 -->
    <div v-if="question.isedit && !istestPreview && !isBankViewTest" class="subject-warp">
      <h4 v-if="isOptionSetting" class="title-h4">Q{{ question.quesIndex + 1 }}题目设置</h4>
      <h4 v-else-if="!isOptionSetting" class="title-h4">选项{{ activeOption.optionIndex + 1 }}的设置</h4>
      <div class="subject-box">
        <!-- 左边的 -->
        <ul class="subject-left">
          <template v-if="!isOptionSetting">
            <li class="subject">
              <span>在选项后边增加填空框</span>
              <div>
                <el-switch v-model="activeOption.haveInput" :active-value="true" :inactive-value="false"></el-switch>
              </div>
            </li>
            <template v-if="activeOption.haveInput">
              <li class="subject">
                <span>格式切换</span>
                <el-select @change="formatChange(activeOption)" size="mini" v-model="activeOption.format" filterable placeholder="不限" :popper-append-to-body="false">
                  <el-option v-for="el in formatList" :key="el.value" :label="el.label" :value="el.value"></el-option>
                </el-select>
              </li>
              <li v-if="activeOption.format == '1'" class="subject">
                <span>位数限制 保留小数点位数</span>
                <div style="display: inline-block; margin-left: 10px">
                  <el-select v-model="activeOption.decimalPlaces" placeholder="请选择" size="mini">
                    <el-option v-for="item in 6" :key="item - 1" :label="item - 1" :value="item - 1"></el-option>
                  </el-select>
                </div>
              </li>
              <li  v-if="activeOption.format != 5 && activeOption.format != 6 && activeOption.format != 7" class="subject">
                <span v-if="activeOption.format == '1'">最大值</span>
                <span v-else>字数限制</span>
                <div class="subject-but">
                  
                  <PopoverNum
                    controls-position="right"
                    :value="activeOption.minNum"
                    :size="'mini'"
                    :min="activeOption.minNum"
                    :max="activeOption.maxNum"
                    :type="'min<max'"
                    :maxlength="4"
                    :content="activeOption.format == '1' ? '最小值不得大于等于最大值' : '最少字数不得大于等于最大字数'"
                    :valueType="activeOption.format == '1' ? 'numValue' : 'lengthValue'"
                    @valueChange="(val) => activeOption.minNum = val"
                  >
                  </PopoverNum>
                  至
                  <PopoverNum
                    controls-position="right"
                    :value="activeOption.maxNum"
                    :size="'mini'"
                    :min="activeOption.minNum"
                    :max="activeOption.maxNum"
                    :type="'min>max'"
                    :maxlength="4"
                    :content="activeOption.format == '1' ? '最大值不得小于等于最小值' : '最多字数不得小于等于最少字数'"
                    :valueType="activeOption.format == '1' ? 'numValue' : 'lengthValue'"
                    @valueChange="(val) => activeOption.maxNum = val"
                  >
                  </PopoverNum>
                </div>
              </li>
              <li class="subject">
                <span>该空可不填</span>
                <el-switch v-model="activeOption.notAnswer" :active-value="true" :inactive-value="false"></el-switch>
              </li>
            </template>
          </template>
          <template v-else-if="isOptionSetting">
            <li class="subject">
              <span>此题必答</span>
              <div>
                <el-checkbox v-model="question.mustanswer" ></el-checkbox>
              </div>
            </li>
            <li class="subject" v-if="question.questionsTypeId != 102">
              <span>选项布局</span>
              <el-radio-group v-model="question.showcolnum" size="mini">
                <el-radio-button  
                  v-for="item in layoutTypeList"
                  :label="item.value" 
                  :key="item.value">
                  {{item.label}}</el-radio-button>
              </el-radio-group>
            </li>
            <!-- 需要加判断 -->
            <li class="subject">
              <span>题型切换</span>
              <el-select :size="'mini'"
                v-model="question.questionsTypeId"
                @change="quesTypeChange"
                :popper-append-to-body="false"
              >
              <el-option
                v-for="item in quesTypeList"
                :key="item.questionsTypeId"
                :label="item.label"
                :value="item.questionsTypeId">
              </el-option>
              </el-select>
            </li>
            <li class="subject">
              <span>选项随机排列</span>
              <el-switch
                v-model="question.optionIfRandom"
                :active-value="1" 
                :inactive-value="0"
                active-color="#1e90ff"
                inactive-color="#ccc"
              >
              </el-switch>
            </li>
            <li class="subject" v-if="question.optionIfRandom">
              <span>固定最后一个选项</span>
              <el-switch
                v-model="question.ifFixedLastOption"
                active-color="#1e90ff"
                inactive-color="#ccc"
                :active-value="1" 
                :inactive-value="0"
              >
              </el-switch>
            </li>
            <li class="subject">
              <span>隐藏该题目</span>
              <el-switch
                v-model="question.isHideTitle"
                active-color="#1e90ff"
                inactive-color="#ccc"
              >
              </el-switch>
            </li>
            <li class="subject">
              <span>难易度</span>
              <el-select  :size="'mini'"
                v-model="question.difficulty"
                :popper-append-to-body="false"
              >
              <el-option
                v-for="item in difficultyList"
                :key="item.difficulty"
                :label="item.label"
                :value="item.value">
              </el-option>
              </el-select>
            </li>
            <li class="subject">
              <span>标签名称</span>
              <!-- <el-select multiple collapse-tags v-model="question.quesLabelName" :popper-append-to-body="false" placeholder="请选择">
                <el-option
                  v-for="item in enumByData"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value">
                </el-option>
              </el-select> -->
              <el-input  type="text" style="width: 220px;"  size="mini" placeholder="请输入标签名称" v-model="question.quesLabelName" maxlength="20" show-word-limit></el-input>
            </li>
          </template>
        </ul>
        <!-- 右边的 -->
        <ul class="subject-right">
          <li class="subject subject-none">
            <span>答案与分值</span>
          </li>
          <!-- 单选题 -->
          <template v-if="question.questionsTypeId == 100">
            <li class="subject subject-none">
              <span>计分方式</span>
              <el-select :size="'mini'"
                :popper-append-to-body="false" @change="scoringTypeChange" v-model="question.scoringType" placeholder="请选择">
                <el-option
                  v-for="item in scoringTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </li>
            
            <template v-if="question.scoringType === 1">
              <!-- <li class="subject subject-none">
                <span>答案</span>
                <el-select :size="'mini'"
                  :key="question.questionsTypeId"
                  :popper-append-to-body="false" 
                  v-model="question.answer" 
                  placeholder="请选择此题答案" 
                >
                  <el-option
                    v-for="(item) in question.optionList"
                    :key="item.oid"
                    :label="$functions.htmlFormat(item.labelName)"
                    :value="item.oid">
                    {{$functions.htmlFormat(item.labelName)}}
                  </el-option>
                </el-select>
              </li> -->
              <li class="subject subject-none">
                <span>此题分值</span>
                
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </li>
            </template>

            <!-- <template v-if="question.scoringType === 2">
              <li class="option-list">
                <div class="option-item"  v-for="(item, index) in question.optionList" :key="index">
                  选项{{index + 1}}
                  <PopoverNum
                    :key="'val' + index"
                    controls-position="right"
                    :value="question.scoreArr[index]"
                    :size="'mini'"
                    :min="1"
                    :max="1000"
                    :content="'请输入1-1000以内的数值'"
                    @valueChange="(val) => optionScoreInput(val, index)"
                  >
                  </PopoverNum>
                </div>
              </li>
            </template> -->

            <!-- <template v-if="question.scoringType === 3">
              <li class="subject subject-none">
                <span>此题分值</span>
                  
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </li>
            </template> -->
          </template>
          <!-- 多选题 -->
          <template v-else-if="question.questionsTypeId == 101">
            <li class="subject subject-none">
              <span>计分方式</span>
              <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.scoringType" placeholder="请选择" :key="'scoringType2'">
                <el-option
                  v-for="item in scoringTypeList2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </li>
            
            
            <template v-if="question.scoringType === 1">
              <!-- <li class="subject subject-none">
                <span>答案</span>
                <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.answer" placeholder="请选择此题答案" multiple>
                  <el-option
                    v-for="(item) in question.optionList"
                    :key="item.oid"
                    :label="$functions.htmlFormat(item.labelName)"
                    :value="item.oid">
                    {{$functions.htmlFormat(item.labelName)}}
                  </el-option>
                </el-select>
              </li> -->
              <li class="subject subject-none">
                <span>此题分值</span>
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </li>
            </template>

            <!-- <template v-if="question.scoringType === 2">
              <li class="subject subject-none">
                <span>答案</span>
                <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.answer" placeholder="请选择此题答案" multiple>
                  <el-option
                    v-for="(item) in question.optionList"
                    :key="item.oid"
                    :label="$functions.htmlFormat(item.labelName)"
                    :value="item.oid">
                    {{$functions.htmlFormat(item.labelName)}}
                  </el-option>
                </el-select>
              </li>
              <li class="subject subject-none">
                <span>少选可得分</span>
                <PopoverNum
                  controls-position="right"
                  :value="question.partialScore"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => partialScoreChange(val,question)"
                >
                </PopoverNum>
              </li>
              
              <li class="subject subject-none">
                <span>此题分值</span>
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="question.partialScore"
                  :max="1000"
                  :content="`请输入${question.partialScore}-1000以内的数值`"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </li>
              
            </template> -->

            <!-- <template v-if="question.scoringType === 3">
              <li class="subject subject-none">
                <span>此题分值</span>
                
                <PopoverNum
                  controls-position="right"
                  :value="question.score"
                  :size="'mini'"
                  :min="1"
                  :max="1000"
                  :content="'请输入1-1000以内的数值'"
                  @valueChange="(val) => question.score = val"
                >
                </PopoverNum>
              </li>
            </template> -->
          </template>
          <template v-else-if="question.questionsTypeId == 102">
            <li class="subject subject-none">
              <span>计分方式</span>
              <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.scoringType" placeholder="请选择" :key="'scoringType3'">
                <el-option
                  v-for="item in scoringTypeList3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </li>

            <!-- <li v-if="question.scoringType == 1" class="subject subject-none">
              <span>答案</span>
              <el-select :size="'mini'"
                :popper-append-to-body="false" v-model="question.answer" placeholder="请选择此题答案" >
                <el-option
                  v-for="(item) in question.optionList"
                  :key="item.oid"
                  :label="$functions.htmlFormat(item.labelName)"
                  :value="item.oid">
                  {{$functions.htmlFormat(item.labelName)}}
                </el-option>
              </el-select>
            </li> -->

            <li class="subject subject-none">
              <span>此题分值</span>
              <PopoverNum
                controls-position="right"
                :value="question.score"
                :size="'mini'"
                :min="1"
                :max="1000"
                :content="'请输入1-1000以内的数值'"
                @valueChange="(val) => question.score = val"
              >
              </PopoverNum>
            </li>
          </template> 
          

          <!-- <div class="subject-daan">
            答案解析
            <el-input
            v-model="question.analysis"
              placeholder="请输入内容"
              type="textarea"
              size="medium"
              resize="none"
            ></el-input>
          </div> -->
        </ul>
      </div>
    </div>
    <el-dialog
      title="批量添加选项"
      :visible.sync="isdialogshow"
	    :close-on-click-modal="false"
    >
    <span>每行代表一个选项，可以添加多个选项</span>
      <el-input
        type="textarea"
        :rows="5"
        placeholder="选项1"
        v-model="optionBatch"
        resize="none"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelAdd">取 消</el-button>
        <el-button size="medium" type="primary" @click="keepBatch"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <SetAnswerAnalysis 
      v-if="question.isedit && !istestPreview && !isBankViewTest"
      :data="question" 
      @updata="(val) => $emit('updataQuestion', val)"
      ref="setAnswerAnalysis" 
    />
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import PopoverNum from "@/components/myComponents/popoverNum.vue"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import OptionAssociation from "./optionAssociation.vue"
import OperateaWrap from './operateaWrap/operateaWrap.vue';
import SetAnswerAnalysis from './operateaWrap/setAnswerAnalysis.vue';
import CheckType from '@/util/JSON/checkType.json';
export default {
  components:{
    TitleEditor,
    PopoverNum,
    OptionAssociation,
    OperateaWrap,
    SetAnswerAnalysis
  },
  props: {
    question: {},
    paper: {
        type: Object,
        default: () => {
            return {}
        }
    },
    questionList: {
        type: Array,
        default: () => {
            return []
        }
    },
    qindex: { type: Number, default: 0 },
    // 单独的试题编辑（只能编辑当前试题 不能复制以及 移动）
    isTestEdit: {
        type: Boolean,
        default: false
    },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
    // 单独试题预览 不能对试题进行操作
    istestPreview: {
        type: Boolean,
        default: false
    },
    bankList: {
        type: Array,
        default: () => {
          return []
        }
    },
    // 题库编辑试题，不能显示是否收藏按钮
    isBank: {
        type: Boolean,
        default: false
    },
  },
  data() {
    return {
		  enumByData:[],
      isdialogshow:false,
      //是否操作选项
      editOptionIndex: -1,
      value: '',
      optionBatch:"",
      // 选项布局
      layoutTypeList: [
        {
          value: 1,
          label: '单列'
        },
        {
          value: 2,
          label: '2列'
        },
        {
          value: 3,
          label: '3列'
        },
        {
          value: 4,
          label: '4列'
        }
      ],
      quesTypeList: [
        {
          label: "单选题",
          questionsTypeId: 100,
        },
        {
          label: "多选题",
          questionsTypeId: 101,
        },
        {
          label: "判断题",
          questionsTypeId: 102,
        },
      ],
      scoringTypeList: [
        {
          value: 1,
          label: '此题唯一答案和分值'
        },
        {
          value: 2,
          label: '每个选项都有对应分值'
        },
        {
          value: 3,
          label: '人工评分'
        }
      ],
      scoringTypeList2: [
        {
          value: 1,
          label: '全部答对才得分'
        },
        {
          value: 2,
          label: '少选可得分'
        },
        {
          value: 3,
          label: '人工评分'
        }
      ],
      scoringTypeList3: [
        {
          value: 1,
          label: '此题唯一答案和分值'
        },
        {
          value: 3,
          label: '人工评分'
        },
      ],
      difficultyList: [
        {
          label: '易',
          value: 1
        },
        {
          label: '较易',
          value: 2
        },
        {
          label: '中',
          value: 3
        },
        {
          label: '较难',
          value: 4
        },
        {
          label: '难',
          value: 5
        }
      ],
      associatedList: [],
      activeOption: {},
      isOptionSetting: true,
			draggableOptions: {
				handle: '.option-handle'
			},
      defaultOptionList: []
    };
  },
  computed: {
    ...mapState(['activeInputId']),
		//选项验证类型
		formatList () {
			return CheckType
		}
	},
  watch: {
    'question.relation': {
      handler(vnew, vold) {
        this.associatedList = []
        if(vnew) {
          vnew.forEach(el => {
            this.questionList.forEach((info) => {
              if (el.id == info.qid) {
                this.associatedList.push(info)
              }
            })
          })
        }
        // console.log(this.associatedList)
      },
      deep: true,
      immediate: true
    },
  },
  created() {
    if(this.question.questionsTypeId == 101 && typeof this.question.answer === 'string' && this.question.answer) {
      if (this.question.answer.indexOf(';') != -1) {
        this.question.answer = this.question.answer.split(';')
      } else {
        let arr = []
        arr.push(this.question.answer)
        this.question.answer = arr
      }
    }
    if (!this.question.difficulty) {
      this.$set(this.question, 'difficulty', 1)
    }
	  this.queryEnumByType()
  
		// 筛选出默认的选项名和id
		this.getdefaultQuesIdAndName()
  },
  methods: {
    ...mapActions(['setActiveInput']),
    getdefaultQuesIdAndName() {
      if (this.question?.qid){
				// 筛选出默认的选项名和id
				this.question?.optionList.forEach((info) => {
					if (info.isDefault) {
						this.defaultOptionList.push(info.oid)
						this.placeholder = this.placeholder ? `${this.placeholder}\n${info.labelName}` : info.labelName
            // console.log('this.placeholder :>> ', this.placeholder, info.labelName);
					}
				})
			}
    },
    formatChange(data) {
			if (data.format == 5 || data.format == 6 || data.format == 7) {
				data.decimalPlaces = 0
				data.minNum = 0
				data.maxNum = 0
			}
			if (data.format == 4 || data.format == 5 || data.format == 6 || data.format == 7){
				data.placeholder = ''
			}
    },
		setQuestionOption(option) {
			this.isOptionSetting = false;
      console.log('this.isOptionSetting :>> ', this.isOptionSetting);
			this.question.optionList.forEach((info, opIndex) => {
        if (info.oid == option.oid) {
          this.activeOption = info;
          this.activeOption.optionIndex = opIndex
        }
      });
		},
    // 多选题：少选可得分
    // partialScoreChange(val, question) {
    //   question.partialScore = val
    //   question.score = val
    // },
	  queryEnumByType() {
	  	let that = this;
	  	let params = {
	  		that: this,
	  		url: `${this.$config.service.queryEnumByType}`,
	  		method: 'POST',
	  		data: {
	  			qid: that.wid,
	  			type:'ks',
	  			pageSize: 10000,
	  			currentPage: 1
	  		},
	  		cb(res) {
	  			// console.log(res);
	  			if (res.code == '0') {
	  					that.enumByData = res.resultBody.records;
	  			} else {
	  				that.enumByData =[]
	  				that.$message.error(res.message);
	  			}
	  		}
	  	};
	  	this.$util.request(params);
	  },
    quesTypeChange() {
      // console.log(this.question.questionsTypeId)
      this.question.scoringType = 1
      if (this.question.questionsTypeId == 101) {
        this.question.answer = []
      }else {
        this.question.answer = ''
      }
      console.log(this.question.answer)
    },
    scoringTypeChange(){
      if (this.question.scoringType == 1) {
        if (this.question.optionList.length > 0) {
          this.question.answer = this.question.optionList[0].oid
        }
      } else {
        this.question.answer = ''
      }
      this.question.score = 5
      this.question.scoreArr = []
      if (this.question.optionList.length > 0) {
        this.question.optionList.forEach(info =>{
          this.question.scoreArr.push(5)
        })
      }
      // console.log(this.question.scoreArr)
    },
    // optionScoreInput(val, index) {
    //   this.$set(this.question.scoreArr, index, val);
    //   this.question.score = Math.max(...this.question.scoreArr)
    // },
    cancelAdd() {
      this.optionBatch = ''
      this.isdialogshow = false
    },
    // 保存批量添加
    keepBatch(){
        this.isdialogshow = false
        let optionArr = this.optionBatch.split('\n')
        this.delOption()
        this.$emit("addOption", this.question.qid, optionArr);
        this.cancelAdd()
    },
    delOption() {
      if (this.defaultOptionList.length > 0) {
        this.question.optionList = this.question.optionList.filter((info => !info.isDefault))
      }
    },
    addOther(){
      this.$emit("addOptionOther", this.question.qid, ['其他'])
    },
    setAnswer() {
      this.$refs.setAnswerAnalysis.dialogVisible = true
      console.log('设置答案与解析 :>> ');
    },
    // 点击切换模态框形式
    cutEdit() {
      console.log('cutEdit :>> ');
      if (!this.isBankViewTest) {
        this.isOptionSetting = true
        this.$emit("cutEdit");
        this.question.isedit = true
      }
    },
    // 点击添加选项
    addOption() {
      this.$emit("addOption", this.question.qid);
    },

    // 点击删除一个选项
    delOptionOne(oid, index) {
      if (this.question.scoreArr && this.question.scoreArr.length > 0) {
        this.question.scoreArr.splice(index, 1)
      }
      this.$emit("delOptionOne", { qid: this.question.qid, oid })
      if(this.question.answer.indexOf(oid) != -1 && this.question.questionsTypeId == 101) {
        this.question.answer.splice(index, 1)
      } else if (this.question.answer.indexOf(oid) != -1){
        this.question.answer = ''
      }
    },
    // 点击删除
    delQuestion() {
      if (this.isBankViewTest) {
        this.delFormBank()
      } else {
        // console.log(this.question.qid);
        this.$emit("delQuestion", this.question.qid);
      }
    },
    // 复制当前题目
    copyQuestion(){
       this.$emit("cutEdit");
      this.$emit('copyQuestion', this.question, this.qindex)
    }
  },
};
</script>

<style scoped lang="scss">
.to-bank{
  color: #424542;
}
.form-bank{
  /deep/.el-button [class*=" el-icon-"], .el-button [class^="el-icon-"]{
    color: #409EFF;
  }
}
.content{
  background-color: rgb(255, 255, 255);
  // line-height: 40px;
  padding: 0 10px;
  margin-bottom: 10px;
}
.outline-none{
  /* display: inline-block; */
  outline: none;
  // max-width: 73%;
}
.box-f{
  width: 89%;
  font-size: 14px;
  display: flex;
}
.box-f span {
  padding-right: 15px;
}
.title-score{
  color: #ccc;
}
.option-true {
  display: inline-block;
  padding: 0 10px;
  font-size: 14;
  color: #409EFF;
}
.delicon {
  font-size: 16px;
  cursor: pointer;
  margin-left: 20px;
  line-height: 30px;
}
.single-wrap {
  background-color: rgb(255, 255, 255);
  line-height: 30px;
  margin-bottom: 5px;
  font-size: 14px;
}
.single-box {
  display: flex;
  justify-content: space-between;
}
.option-li-div{
  width: 70%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding-left: 10px;
  border: 1px dashed #fff;
}
.option-li:hover{
  .option-li-div{
    border: 1px dashed #aaa;
    background-color: #f4f4f4;
  }
}
.circle-radio {
  display: inline-block;
  border: 1px solid #dcdfe6;
  border-radius: 100%;
  width: 14px;
  height: 14px;
  background-color: #fff;
  box-sizing: border-box;
}
.circle-checkbox{
  display: inline-block;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  background-color: #fff;
  margin: 8px 10px 8px 0;
}
.div-input {
  // display: flex;
  // flex: 1;
  margin: 0 25px;
  width: 100%;
  font-size: 14px;
  font-family: Arial;
  color: #606266;
}
.option {
  width: 100%;
  margin-left: 23px;
  display: flex;
  flex-wrap: wrap;
}
.other-input{
    width: 80px;
    margin-left: 10px;
    
}
.other-input /deep/.el-input--mini .el-input__inner{
  height: 22px;
  line-height: 22px;
}
.option li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 30px;
  line-height: 30px;
  margin-top: 10px;
}
.option-bottom {
  display: flex;
  padding-left: 40px;
  background-color: rgb(255, 255, 255);
}
.subject {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #999;
  align-items: center;
}
/* .subject-row {
  display: flex;
}
.subject-row li span {
  border: 1px solid #999;
  padding: 0 5px;
} */
.subject-box {
  display: flex;
  justify-content: space-around;
  line-height: 60px;
}
/* .subject-box ul {
    flex: 1;
} */
.subject-right {
  background-color: rgba(242, 242, 242, 1);
  padding: 0 20px 20px 20px;
  height: 100%;
}
.el-switch {
  margin-top: 15px;
}
.subject-warp {
  background-color: rgb(255, 255, 255);
  border-top: 1px solid #999;
  font-size: 14px;
  /* height: 400px; */
  padding-bottom: 20px;
}
.subject-daan {
  line-height: 30px;
}
.subject-none {
  border: none;
  line-height: 50px;
}
.title-h4 {
  padding-left: 30px;
}
.option-list{
  width: 273px;
  display: flex;
  flex-wrap: wrap;
}
.option-item{
  line-height: 25px;
  width: 50%;
}
/deep/.el-dropdown-menu{
  min-width: 220px;
}
.associated{
  display: block;
  color: #aaa;
}
.control{
  width: 200px;
  margin-right: 10px;
}
.el-icon-common-option {
  margin-left: 10px;
  font-size: 16px;
  line-height: 30px !important;
  color: cornflowerblue;
  cursor: pointer;
}
</style>